module.exports = __webpack_public_path__ + "static/media/signage-indoor-img66.5d9d6232.jpg";